<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container" dir="" id="studyContainer">
        <div id="study-body">
          <transition name="fade" mode="out-in">
            <component :is="setComponentName" @startStudy="startStudy" />
          </transition>
        </div>
      </div>
    </div>
    <transition name="slide" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
/**
 * 컨텐츠 학습창 메인 컴포넌트(Content learning main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import "@/scss/study.scss";
import "@/css/study.css";

import learnApi from "@/api/learnApi.js";
import Objective from "../components/study/Objective.vue";
import VideoType from "../components/study/VideoType.vue";
import SlideType from "../components/study/SlideType.vue";
import PdfType from "../components/study/PdfType2.vue";
import HtmlType from "../components/study/HtmlType.vue";
import ExamIntro from "../components/exam/Intro.vue";
import InteractiveHtmlType from '../components/study/InteractiveHtmlType.vue'

export default {
  name: "stduyContainer",
  components: {
    Objective,
    VideoType,
    SlideType,
    PdfType,
    HtmlType,
    ExamIntro,
    InteractiveHtmlType
  },

  data() {
    return {
      componentName: "Objective",
      lessonData: null,
      lessonContentType: "",
    };
  },

  computed: {
    setComponentName() {
      return this.componentName;
    },
  },

  created() {
    this.fatchData();
  },

  watch: {
    $route(to, from) {
      if (
        to.params.progressionId.toString() !==
        from.params.progressionId.toString()
      ) {
        this.fatchData("Objective");
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    this.$parent.fetchData();
    this.$parent.$refs.contentsComp.fetchData();
    next();
  },

  methods: {
    // get lesson data
    fatchData(componentName) {
      if (componentName) {
        this.componentName = componentName;
      }

      let params = this.setParams();

      learnApi
        .learnLessonContents(params)
        .then((response) => {
          let responseData = response.data.data;
          this.lessonData = responseData;
          this.lessonContentType = this.lessonData.type.value;
        })
        .catch((err) => {});
    },

    // 학습 창으로 이동(move learning contents)
    startStudy() {
      console.log("this.lessonContentType ", this.lessonContentType);
      if (this.lessonContentType === 'VIDEO') {
          this.componentName = 'VideoType'
      }else if (this.lessonContentType === 'SLIDE') {
          this.componentName = 'SlideType'
      }else if (this.lessonContentType === 'PDF') {
          this.componentName = 'PdfType'
      }else if (this.lessonContentType === 'HTML'){
          this.componentName = 'HtmlType'
      }else if (this.lessonContentType === 'INTERACTIVE_HTML'){
          this.componentName = 'InteractiveHtmlType'
      }
    },

    // set ContentsType
    setContentsType(type) {
      this.componentName = type;
    },

    // set parameter
    setParams() {
      let params = {
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };
      return params;
    },
  },
};
</script>